var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tag",on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.tagName))])
}
var staticRenderFns = []

export { render, staticRenderFns }